import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { WebLink } from '@/components/functional/Link/WebLink';
import { buttonBaseHeight, buttonBaseWidth, buttonBaseSpaces, buttonBaseTextSizes, } from '@/components/ui/Button/ButtonBase';
import { Text } from '@/components/ui/Typography/Body/Text';
/**
 * buttonデザインのLinkのラッパーコンポーネント
 * @param props
 * @constructor
 */
export const LinkButtonBase = (props) => {
    const { children, className = '', disabled, externalLinkAttributes, isBordered = true, isFull = false, isFullRounded = false, onClick, routerLinkAttributes, size, target, textClassName = '', textColor, to, } = props;
    return (_jsx(WebLink, Object.assign({ className: clsx('flex justify-center items-center', isBordered && 'border border-solid', isFullRounded ? 'rounded-full' : 'rounded-md', isFull ? 'w-full' : buttonBaseWidth[size], buttonBaseHeight[size], disabled
            ? 'opacity-50 hover:cursor-default pointer-events-none'
            : 'hover:cursor-pointer', 'hover:no-underline', buttonBaseSpaces[size], className), disabled: disabled, externalLinkAttributes: externalLinkAttributes, onClick: onClick, routerLinkAttributes: routerLinkAttributes, target: target, to: to }, { children: _jsx(Text, Object.assign({ className: textClassName, color: textColor, size: buttonBaseTextSizes[size], tagName: 'span' }, { children: children })) })));
};
